var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:{
	'window-stack-view': true,
	active: _vm.windows.length > 0
},attrs:{"name":"list"}},_vm._l((_vm.windows),function(win,i){return _c(win.component,_vm._b({key:i,tag:"component",class:{
		window: true,
		active: i == _vm.windows.length - 1
	},on:{"pop":function($event){return _vm.$emit('pop')}}},'component',win,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }